export const trackMakeOfferModalOpened = ({ purchaseTracking, url, isTrade }) => {
    purchaseTracking.ecommerceAddToCartTracking({
        url,
        isTrade,
    });
    purchaseTracking.trackOfferEvent({
        actionPrefix: 'offer selected',
        actionSuffix: 'make offer button',
        objectName: 'button',
    });
};



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/MakeOfferButton/trackingHelpers.es.js